import styled from 'styled-components';

import colors from '~/styles/colors';

export const TextInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  label {
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-weight: bold;
    color: ${colors.blue900};
    font-size: 14px;
    line-height: 16px;
  }

  input,
  textarea {
    border: 2px solid ${colors.grey600};
    border-radius: 30px;
    height: 48px;
    padding: 0 15px;
    color: ${colors.blue900};
    width: 100%;

    &::placeholder {
      color: ${colors.grey600};
      height: 19px;
      margin: 0 0 10px;
      font-size: 16px;
      line-height: 19px;
    }
  }

  textarea {
    padding: 15px;
    height: 150px;
  }

  span {
    margin-top: 8px;
    color: ${colors.red100};
    align-self: flex-start;
    font-weight: bold;
  }
`;
